//#region src/Storage.ts
var Storage = class {
	constructor(adapter, onFailure) {
		this.adapter = adapter;
		this.onFailure = onFailure;
	}
	async commit(writeOps) {
		try {
			await this.adapter.commit(writeOps);
		} catch (error) {
			this.onFailure(error);
		}
	}
	async scan(args) {
		return await this.adapter.scan(args);
	}
	async clear() {
		await this.adapter.clear();
	}
};

//#endregion
export { Storage };